import { a } from './_csAbt';

import * as _gp from './_csGbl';
import * as _hm from './_hf';
import * as ht from './_ht';
import * as cr from './_cr';

import * as BtnC from './_cccBtnC';
import * as GridC from './_cccGridC';

export const N = (pz: ht.btnTopCz) => {
  return (
    cr.c(GridC.N, {
      key: -40,
      abtType: 'barBtnViewCmnz',
      lineCs: [{
        cellCs: [
          {
            oClds: [
              cr.c(BtnC.N, {
                key: -10,
                abtType: 'backCmnz',
                lblCz: {
                  textz: {
                    pfx: pz.cz.lblz.btnz.topz.back,
                  },
                },
                pslPtyz: {
                  onPress: pz.cz.onPrsBack,
                },
              }),
            ]
          },
          pz.cz.bCrt != false ?
          {
            oClds: [
              cr.c(BtnC.N, {
                key: -20,
                abtType: 'nextCmnz',
                //boxStlz: a(`sc/${pz.cz.sc ?? 'lt7'}`),
                lblCz: {
                  textz: {
                    pfx: pz.cz.lblz.btnz.topz.new,
                  },
                },
                pslPtyz: {
                  onPress: () => {
                    pz.sPz.set({
                      steps: [1],
                      phs: 'crt',
                    })
                  }
                },
              }),
            ]
          }
          : null,
        ]
      }]
    })
  );
}; 
